import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=c2ffb6fc"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ffb6fc')) {
      api.createRecord('c2ffb6fc', component.options)
    } else {
      api.reload('c2ffb6fc', component.options)
    }
    module.hot.accept("./TermsOfUse.vue?vue&type=template&id=c2ffb6fc", function () {
      api.rerender('c2ffb6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_terms/TermsOfUse.vue"
export default component.exports